import { FC, ComponentProps } from 'react';
import { graphql, useLazyLoadQuery, usePreloadedQuery, PreloadedQuery } from 'react-relay';
import { CustomsMessagingRendererQuery } from './__generated__/CustomsMessagingRendererQuery.graphql';
import CustomsMessagingBody from './CustomsMessagingBody';

type PassThroughProps = Omit<ComponentProps<typeof CustomsMessagingBody>, 'viewer'>;
export type CustomsMessagingRendererProps = PassThroughProps & {
    userId?: string | null;
    itemId?: string | null;
    destinationCountry?: string | undefined;
};
type PreloadedCustomsMessagingRendererProps = PassThroughProps & {
    queryReference: PreloadedQuery<CustomsMessagingRendererQuery>;
};
export type QueryType = CustomsMessagingRendererQuery;
export const query = graphql`
    query CustomsMessagingRendererQuery(
        $userId: String
        $itemId: String
        $destinationCountry: String
    ) {
        viewer {
            ...CustomsMessagingBody_viewer
        }
    }
`;

export const PreloadedCustomsMessagingRenderer: FC<PreloadedCustomsMessagingRendererProps> = ({
    currency = '',
    isAuction = false,
    queryReference,
    wrapperClass,
    messageClass,
}) => {
    const { viewer } = usePreloadedQuery<CustomsMessagingRendererQuery>(query, queryReference);

    {
        return (
            <CustomsMessagingBody
                viewer={viewer}
                currency={currency}
                isAuction={isAuction}
                wrapperClass={wrapperClass}
                messageClass={messageClass}
            />
        );
    }
};

const CustomsMessagingRenderer: FC<CustomsMessagingRendererProps> = ({
    userId = '',
    itemId,
    destinationCountry = null,
    currency = '',
    isAuction = false,
    wrapperClass,
    messageClass,
}) => {
    const { viewer } = useLazyLoadQuery<CustomsMessagingRendererQuery>(query, {
        userId,
        itemId,
        destinationCountry,
    });

    {
        return (
            <CustomsMessagingBody
                viewer={viewer}
                currency={currency}
                isAuction={isAuction}
                wrapperClass={wrapperClass}
                messageClass={messageClass}
            />
        );
    }
};

export default CustomsMessagingRenderer;
